import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LandTitleDto } from '@cradua/data';

@Component({
  selector: 'pipelineassetpopup-list',
  templateUrl: './pipelineassetpopup-list.component.html',
  styleUrls: ['./pipelineassetpopup-list.component.scss']
})
export class PipelineassetpopupListComponent implements OnInit {

  @Input() landTitles: LandTitleDto[];
  @Output() emitLandTitle = new EventEmitter<any>();
  @Output() taskEmit = new EventEmitter<any>();
  constructor() { }

  ngOnInit(): void {}

  onTaskEmit() {

  }

  onView(value) {
    this.emitLandTitle.emit(value);
  }

}
